var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModifySearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.95898V7.79232L0.5 4.25065L5 0.708984V3.54232H8.75C10.3413 3.54232 11.8674 4.13934 12.9926 5.20205C14.1179 6.26475 14.75 7.70609 14.75 9.20898C14.75 10.7119 14.1179 12.1532 12.9926 13.2159C11.8674 14.2786 10.3413 14.8757 8.75 14.8757H2V13.459H8.75C9.94347 13.459 11.0881 13.0112 11.932 12.2142C12.7759 11.4172 13.25 10.3362 13.25 9.20898C13.25 8.08181 12.7759 7.00081 11.932 6.20378C11.0881 5.40675 9.94347 4.95898 8.75 4.95898H5Z",
    fill: "#F0B64F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifySearchIcon);
export default __webpack_public_path__ + "static/media/modify_search_icon.fdcc3b3bc163511a86fc0495339fecac.svg";
export { ForwardRef as ReactComponent };